import React from 'react';
import classNames from 'classnames';

const BlogHelloWorld = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const outerClasses = classNames(
    'hero section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section
        className={outerClasses}
      >
        <div className="container-sm">
          <div className={innerClasses}>
            <div className="hero-figure reveal-from-bottom illustration-element-01" data-reveal-value="20px" data-reveal-delay="800">
              <div className="center-content">
                <h1>The Ultimatum</h1>
                <h3>by Timothy</h3>
                <i><h4>Terms and conditions may apply.</h4></i>
              </div>
              <br></br>
              <p>
              <strong>
                The best form of a revenge
              </strong>
              <br></br><br></br>
            is living a good, prosperous life.
              </p>
            </div>
          </div>
        </div>
      </section>
  );
}

export default BlogHelloWorld;